"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.array.from");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.map");
var _objectSpread2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _axios = _interopRequireDefault(require("axios"));
var _allowance = require("@/http/interface/sfe/allowance");
var _index = require("@/utils/index");
var _SignMap = _interopRequireDefault(require("./components/SignMap.vue"));
var _elementUi = require("element-ui");
var _statics = require("@/views/sfe/doubleWeekPlan/statics");
var _moment = _interopRequireDefault(require("moment"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/** package */
/** components */
/** services */
/** utils */
var _default = exports.default = {
  components: {
    SignMap: _SignMap.default
  },
  data: function data() {
    return {
      role: '',
      /** page common */
      pageName: 'oilAllowance',
      /** enum */
      optConfig: {
        PTFlagOptions: [{
          name: this.$t('doubleWeekPlan.enum.all'),
          code: ''
        }, {
          name: this.$t('doubleWeekPlan.enum.plan'),
          code: _statics.PT_STATUS_PLAN
        }, {
          name: this.$t('doubleWeekPlan.enum.task'),
          code: _statics.PT_STATUS_TASK
        }],
        dailySignRecordStatusOptions: [],
        driveTypeOptions: [],
        planTaskTypeOptions: [],
        signTypeOptions: [],
        auditStatusOptions: []
      },
      /** search group */
      searchVal: {
        empNo: '',
        empName: '',
        status: '',
        startDay: '',
        endDay: '',
        teamType: ''
      },
      /** table group */
      table: {
        listLoading: false,
        list: [],
        total: 0,
        currPage: 1,
        limit: 10,
        sourceApi: null // api timer
      },
      table2: {
        listLoading: false,
        list: [],
        total: 0,
        currPage: 1,
        limit: 10,
        sourceApi: null // api timer
      },
      table3: {
        listLoading: false,
        list: [],
        total: 0,
        currPage: 1,
        limit: 10,
        sourceApi: null // api timer
      },
      table4: {
        listLoading: false,
        list: [],
        total: 0,
        currPage: 1,
        limit: 10,
        sourceApi: null // api timer
      },
      table5: {
        listLoading: false,
        list: [],
        total: 0,
        currPage: 1,
        limit: 10,
        sourceApi: null // api timer
      },
      table6: {
        listLoading: false,
        list: [],
        total: 0,
        currPage: 1,
        limit: 10,
        sourceApi: null // api timer
      },
      dailySignRecordPk: '',
      planTaskInfoPk: '',
      /** others */
      loadingComponent: null,
      isLoading: false,
      isShowModelView: false,
      isShowModelApproveHistoryView: false,
      isShowModelRouteView: false,
      isShowModelAuditView: false,
      isShowDetailModelView: false,
      isShowModelApproveDetailView: false,
      form: {
        auditStatus: '',
        refuseReason: '',
        planTaskIdList: []
      },
      formLabelWidth: '120px',
      lookupList: {}
    };
  },
  computed: {
    startPickerOptions: function startPickerOptions() {
      var _this = this;
      return {
        disabledDate: function disabledDate(time) {
          var timeGetTime = time.getTime();
          var endDay = _this.searchVal.endDay;
          if (endDay) {
            var maxDate = (0, _moment.default)(endDay, 'YYYYMMDD').toDate();
            var minDate = (0, _moment.default)(endDay, 'YYYYMMDD').subtract(30, 'days');
            if (timeGetTime > maxDate || timeGetTime < minDate) {
              return true;
            }
          } else {
            var _maxDate = (0, _moment.default)();
            if (timeGetTime > _maxDate) {
              return true;
            }
          }
          return false;
        }
      };
    },
    endPickerOptions: function endPickerOptions() {
      var _this = this;
      return {
        disabledDate: function disabledDate(time) {
          var timeGetTime = time.getTime();
          var startDay = _this.searchVal.startDay;
          if (startDay) {
            var minDate = (0, _moment.default)(startDay, 'YYYYMMDD').toDate();
            var maxDate = (0, _moment.default)(startDay, 'YYYYMMDD').add(30, 'days'); // 向后30天
            var maxDate2 = (0, _moment.default)() > maxDate ? maxDate : (0, _moment.default)();
            if (timeGetTime < minDate || timeGetTime > maxDate2) {
              return true;
            }
          } else {
            var _maxDate2 = (0, _moment.default)();
            if (timeGetTime > _maxDate2) {
              return true;
            }
          }
          return false;
        }
      };
    },
    teamType: function teamType() {
      return this.$store.getters.teamType;
    }
  },
  watch: {
    isLoading: function isLoading(newValue) {
      // pc unlock 锁屏会导致页面晃动
      if (newValue) {
        this.loadingComponent = this.$loading({
          // lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0)'
        });
      } else {
        if (this.loadingComponent) {
          this.loadingComponent.close();
        }
      }
    },
    '$store.getters.language': function $storeGettersLanguage(newValue) {
      // 监听语言变更重新请求配置查询接口
      this.queryEnumOptions();
      this.getLookupTypeCode();
    }
  },
  mounted: function mounted() {
    var _this2 = this;
    this.role = this.$store.getters.roles[0];
    this.queryEnumOptions();
    this.getLookupTypeCode();
    setTimeout(function () {
      _this2.searchVal.startDay = (0, _moment.default)().subtract(30, 'days').format('YYYYMMDD');
      _this2.searchVal.endDay = (0, _moment.default)().format('YYYYMMDD');
      _this2.searchData();
    }, 300);
    console.log(this.role);
  },
  methods: {
    /**
     * 枚举
     */
    /** 格式化 枚举 */
    formatEnum: function formatEnum(key, from) {
      if (key) {
        return (0, _index.formatKeyValue)("".concat(key), this.optConfig[from]);
      }
      return '';
    },
    /** 获取计划类型 enum */queryEnumOptions: function queryEnumOptions() {
      var _this3 = this;
      var dailySignRecordStatus_key = 'DAILY_SIGN_RECORD_STATUS'; // 自身品牌 dailySignRecordStatus
      var planTaskType_key = 'PLAN_TASK_TYPE'; // 自身品牌 dailySignRecordStatus
      var driveType_key = 'DRIVE_TYPE'; // 自身品牌 dailySignRecordStatus
      var signType_key = 'SIGN_TYPE'; // 自身品牌 dailySignRecordStatus
      var auditStatus_key = 'AUDIT_STATUS'; // 自身品牌 dailySignRecordStatus
      var param = {
        configItemCodeList: [dailySignRecordStatus_key, driveType_key, planTaskType_key, signType_key, auditStatus_key]
      };
      this.$api.common.getConfigItemByCode(param).then(function (res) {
        var data = res.data || {};
        _this3.optConfig.dailySignRecordStatusOptions = data[dailySignRecordStatus_key] || [];
        _this3.optConfig.planTaskTypeOptions = data[planTaskType_key] || [];
        _this3.optConfig.driveTypeOptions = data[driveType_key] || [];
        _this3.optConfig.signTypeOptions = data[signType_key] || [];
        _this3.optConfig.auditStatusOptions = data[auditStatus_key] || [];
        console.log(_this3.optConfig.dailySignRecordStatusOptions);
      });
    },
    /**
     * search methods
     */
    // 搜索
    searchData: function searchData() {
      this.table.currPage = 1;
      this.fetchData();
    },
    // resert saerch
    resetData: function resetData() {
      var data = this.$options.data.call(this);
      this.searchVal = data.searchVal;
      this.searchData();
    },
    /**
     * table methods
     */
    // 获取 列表
    fetchData: function fetchData() {
      var _this4 = this;
      if (this.table.sourceApi) {
        this.table.sourceApi.cancel('cancel');
      }
      this.table.sourceApi = _axios.default.CancelToken.source();
      var param = {
        currPage: this.table.currPage,
        limit: this.table.limit,
        smodel: (0, _objectSpread2.default)({}, this.searchVal)
      };
      this.table.listLoading = true;
      (0, _allowance.getOilAllowanceList)(param, this.table.sourceApi.token).then(function (res) {
        var _ref = res.data || [],
          items = _ref.items,
          totalCount = _ref.totalCount;
        _this4.table.list = items;
        _this4.table.total = totalCount;
      }).catch(function (err) {
        if (_axios.default.isCancel(err)) {
          return false;
        }
      }).finally(function () {
        _this4.table.listLoading = false;
      });
    },
    fetchSignList: function fetchSignList() {
      var _this5 = this;
      if (this.table2.sourceApi) {
        this.table2.sourceApi.cancel('cancel');
      }
      this.table2.sourceApi = _axios.default.CancelToken.source();
      var param = {
        currPage: this.table2.currPage,
        limit: this.table2.limit,
        smodel: {
          dailySignRecordPk: this.dailySignRecordPk
        }
      };
      this.table2.listLoading = true;
      (0, _allowance.getSignTaskDetailList)(param, this.table2.sourceApi.token).then(function (res) {
        _this5.isShowModelView = true;
        var _ref2 = res.data || [],
          items = _ref2.items,
          totalCount = _ref2.totalCount;
        _this5.table2.list = items;
        _this5.table2.total = totalCount;
      }).catch(function (err) {
        if (_axios.default.isCancel(err)) {
          return false;
        }
      }).finally(function () {
        _this5.table2.listLoading = false;
      });
    },
    fetchApproveHistoryList: function fetchApproveHistoryList() {
      var _this6 = this;
      if (this.table3.sourceApi) {
        this.table3.sourceApi.cancel('cancel');
      }
      this.table3.sourceApi = _axios.default.CancelToken.source();
      var param = {
        currPage: this.table3.currPage,
        limit: this.table3.limit,
        smodel: {
          dailySignRecordPk: this.dailySignRecordPk
        }
      };
      this.table3.listLoading = true;
      (0, _allowance.getApprovalHistoryList)(param, this.table3.sourceApi.token).then(function (res) {
        _this6.isShowModelApproveHistoryView = true;
        var _ref3 = res.data || [],
          items = _ref3.items,
          totalCount = _ref3.totalCount;
        _this6.table3.list = items;
        _this6.table3.total = totalCount;
      }).catch(function (err) {
        if (_axios.default.isCancel(err)) {
          return false;
        }
      }).finally(function () {
        _this6.table3.listLoading = false;
      });
    },
    fetchApproveSignList: function fetchApproveSignList() {
      var _this7 = this;
      if (this.table4.sourceApi) {
        this.table4.sourceApi.cancel('cancel');
      }
      this.table4.sourceApi = _axios.default.CancelToken.source();
      var param = {
        currPage: this.table4.currPage,
        limit: this.table4.limit,
        smodel: {
          dailySignRecordPk: this.dailySignRecordPk,
          isApproveHistoryList: 'Y'
        }
      };
      this.table4.listLoading = true;
      (0, _allowance.getApporveDetailList)(param, this.table4.sourceApi.token).then(function (res) {
        _this7.isShowModelAuditView = true;
        _this7.form.auditStatus = '';
        _this7.form.refuseReason = '';
        _this7.form.planTaskIdList = [];
        var _ref4 = res.data || [],
          items = _ref4.items,
          totalCount = _ref4.totalCount;
        _this7.table4.list = items;
        _this7.table4.total = totalCount;
      }).catch(function (err) {
        if (_axios.default.isCancel(err)) {
          return false;
        }
      }).finally(function () {
        _this7.table4.listLoading = false;
      });
    },
    fetchDetailSignList: function fetchDetailSignList() {
      var _this8 = this;
      if (this.table5.sourceApi) {
        this.table5.sourceApi.cancel('cancel');
      }
      this.table5.sourceApi = _axios.default.CancelToken.source();
      var param = {
        currPage: this.table5.currPage,
        limit: this.table5.limit,
        smodel: {
          planTaskInfoPk: this.planTaskInfoPk
        }
      };
      this.table5.listLoading = true;
      (0, _allowance.getApporveDetailA03List)(param, this.table5.sourceApi.token).then(function (res) {
        _this8.isShowDetailModelView = true;
        var _ref5 = res.data || [],
          items = _ref5.items,
          totalCount = _ref5.totalCount;
        _this8.table5.list = items;
        _this8.table5.total = totalCount;
      }).catch(function (err) {
        if (_axios.default.isCancel(err)) {
          return false;
        }
      }).finally(function () {
        _this8.table5.listLoading = false;
      });
    },
    fetchApproveDetailSignList: function fetchApproveDetailSignList() {
      var _this9 = this;
      if (this.table6.sourceApi) {
        this.table6.sourceApi.cancel('cancel');
      }
      this.table6.sourceApi = _axios.default.CancelToken.source();
      var param = {
        currPage: this.table6.currPage,
        limit: this.table6.limit,
        smodel: {
          dailySignRecordPk: this.dailySignRecordPk,
          isApproveHistoryList: 'Y'
        }
      };
      this.table6.listLoading = true;
      (0, _allowance.getApporveDetailList)(param, this.table6.sourceApi.token).then(function (res) {
        // this.isShowModelApproveDetailView = true
        var _ref6 = res.data || [],
          items = _ref6.items,
          totalCount = _ref6.totalCount;
        _this9.table6.list = items;
        _this9.table6.total = totalCount;
      }).catch(function (err) {
        if (_axios.default.isCancel(err)) {
          return false;
        }
      }).finally(function () {
        _this9.table6.listLoading = false;
      });
    },
    // 导出excel
    downloadExcel: function downloadExcel(name) {
      var _this0 = this;
      var param = (0, _objectSpread2.default)({}, this.searchVal);
      this.isLoading = true;
      (0, _allowance.exportOilAllowanceList)(param).then(function (res) {
        (0, _index.downloadFileExcel)(name, res.data);
      }).finally(function () {
        _this0.isLoading = false;
      });
    },
    downloadExcel2: function downloadExcel2(name) {
      var _this1 = this;
      if (!this.searchVal.startDay || !this.searchVal.endDay) {
        (0, _elementUi.Message)({
          message: '请选择日期',
          type: 'error',
          duration: 1.5 * 1000
        });
        return;
      }
      var param = (0, _objectSpread2.default)({}, this.searchVal);
      this.isLoading = true;
      (0, _allowance.exportWeekOilAllowanceList)(param).then(function (res) {
        (0, _index.downloadFileExcel)(name, res.data);
      }).finally(function () {
        _this1.isLoading = false;
      });
    },
    downloadExcelDetail: function downloadExcelDetail(name) {
      var _this10 = this;
      console.log('downloadExcelDetail', this.searchVal);
      if (!this.searchVal.startDay || !this.searchVal.endDay) {
        (0, _elementUi.Message)({
          message: '请选择日期',
          type: 'error',
          duration: 1.5 * 1000
        });
        return;
      }
      var param = (0, _objectSpread2.default)({}, this.searchVal);
      this.isLoading = true;
      (0, _allowance.exportOilAllowanceDetailList)(param).then(function (res) {
        (0, _index.downloadFileExcel)(name, res.data);
      }).finally(function () {
        _this10.isLoading = false;
      });
    },
    paddingNum: function paddingNum(inputParam) {
      return (0, _index.paddingNum)(inputParam);
    },
    viewRoute: function viewRoute(row) {
      this.dailySignRecordPk = row.dailySignRecordPk;
      this.$refs['signMap'].init();
      // this.isShowModelRouteView = true
    },
    viewDetail: function viewDetail(row) {
      this.dailySignRecordPk = row.dailySignRecordPk;
      this.fetchSignList();
    },
    viewApproveHistory: function viewApproveHistory(row) {
      this.dailySignRecordPk = row.dailySignRecordPk;
      this.fetchApproveHistoryList();
      this.fetchApproveDetailSignList();
    },
    viewApproveDetail: function viewApproveDetail(row) {
      this.planTaskInfoPk = row.planTaskInfoPk;
      this.fetchDetailSignList();
    },
    signSubmitClick: function signSubmitClick(row) {
      var _this11 = this;
      this.isLoading = true;
      var param = {
        dailySignRecordPk: row.dailySignRecordPk
      };
      (0, _allowance.allowanceSignSubmit)(param).then(function (res) {
        console.log('allowanceSignSubmit=======', res);
        _this11.isLoading = false;
        if (res.success) {
          if (res.errorInfos && res.errorInfos.length > 0) {
            _elementUi.MessageBox.confirm('今日仍有任务未补签，是否放弃补签进入审批？', '提示', {
              confirmButtonText: '提交进入审批',
              cancelButtonText: '不提交',
              type: 'warning'
            }).then(function () {
              console.log('走第二步提交');
              _this11.signSubmit(row.dailySignRecordPk);
            }).catch(function () {
              console.log('cancel');
            });
          } else {
            _elementUi.MessageBox.confirm('确认提交审批吗', '提示', {
              confirmButtonText: _this11.$t('common.submit'),
              cancelButtonText: _this11.$t('common.cancel'),
              type: 'warning'
            }).then(function () {
              // console.log('走第二步提交')
              _this11.signSubmit(row.dailySignRecordPk);
            }).catch(function () {
              console.log('cancel');
            });
          }
        }
      }).catch(function (err) {
        console.log('=====err=====', err);
        _this11.isLoading = false;
      });
    },
    signSubmit: function signSubmit(dailySignRecordPk) {
      var _this12 = this;
      this.isLoading = true;
      var param = {
        dailySignRecordPk: dailySignRecordPk
      };
      (0, _allowance.allowanceSubmit)(param).then(function (res) {
        _this12.isLoading = false;
        if (res.success) {
          (0, _elementUi.Message)({
            message: '提交成功',
            type: 'success',
            duration: 1.5 * 1000
          });
          _this12.searchData();
        } else {
          if (res.errorInfos && res.errorInfos.length > 0) {
            setTimeout(function () {
              (0, _elementUi.Message)({
                message: res.errorInfos[0]['errMsg'] || 'Error',
                type: 'error',
                duration: 1.5 * 1000
              });
            });
          }
        }
      }).catch(function (err) {
        console.log(err);
        _this12.isLoading = false;
      });
    },
    auditClick: function auditClick(row) {
      this.dailySignRecordPk = row.dailySignRecordPk;
      this.fetchApproveSignList();
    },
    closeView: function closeView() {
      this.isShowModelView = false;
    },
    closeApproveHistoryView: function closeApproveHistoryView() {
      this.isShowModelApproveHistoryView = false;
    },
    closeApproveDetailView: function closeApproveDetailView() {
      this.isShowDetailModelView = false;
    },
    closeApproveDetailView2: function closeApproveDetailView2() {
      this.isShowModelApproveDetailView = false;
    },
    saveAuditView: function saveAuditView() {
      if (this.form.auditStatus === '') {
        (0, _elementUi.Message)({
          message: '请选择审批状态',
          type: 'error',
          duration: 1.5 * 1000
        });
        return;
      }
      if (this.form.auditStatus === '30' && this.form.refuseReason === '') {
        (0, _elementUi.Message)({
          message: '请填写拒绝原因',
          type: 'error',
          duration: 1.5 * 1000
        });
        return;
      }
      if (this.form.auditStatus === '30' && this.form.planTaskIdList.length === 0) {
        (0, _elementUi.Message)({
          message: '请选择拒绝的任务',
          type: 'error',
          duration: 1.5 * 1000
        });
        return;
      }
      this.auditSubmit();
    },
    auditSubmit: function auditSubmit() {
      var _this13 = this;
      var planTaskIdList = this.form.planTaskIdList.map(function (i) {
        return i.planTaskInfoPk;
      });
      console.log(planTaskIdList);
      this.isLoading = true;
      var param = {
        dailySignRecordPk: this.dailySignRecordPk,
        auditStatus: this.form.auditStatus,
        refuseReason: this.form.refuseReason,
        planTaskIdList: planTaskIdList
      };
      (0, _allowance.allowanceAudit)(param).then(function (res) {
        _this13.isLoading = false;
        if (res.success) {
          (0, _elementUi.Message)({
            message: '审批成功',
            type: 'success',
            duration: 1.5 * 1000
          });
          _this13.isShowModelAuditView = false;
          _this13.form.auditStatus = '';
          _this13.form.refuseReason = '';
          _this13.searchData();
        } else {
          if (res.errorInfos && res.errorInfos.length > 0) {
            setTimeout(function () {
              (0, _elementUi.Message)({
                message: res.errorInfos[0]['errMsg'] || 'Error',
                type: 'error',
                duration: 1.5 * 1000
              });
            });
          }
        }
      }).catch(function (err) {
        console.log(err);
        _this13.isLoading = false;
      });
    },
    handleCheckedMain: function handleCheckedMain(rows) {
      console.log(999, rows);
      if (this.table4.listLoading) {
        return false;
      }
      // 当前页选中
      var checkedCodes = rows.map(function (i) {
        return i.planTaskInfoPk;
      });
      // 当前页取消选中
      var unCheckedRows = this.table4.list.filter(function (i) {
        return checkedCodes.indexOf(i.planTaskInfoPk) < 0;
      });
      var unCheckedCodes = unCheckedRows.map(function (i) {
        return i.planTaskInfoPk;
      });
      var rowsMap = new Map();
      this.form.planTaskIdList.concat(rows).forEach(function (i) {
        rowsMap.set(i.planTaskInfoPk, i);
      });
      var arr = Array.from(rowsMap.values()).filter(function (i) {
        return unCheckedCodes.indexOf(i.planTaskInfoPk) < 0;
      });
      this.form.planTaskIdList = arr;
    },
    isRowSelectable: function isRowSelectable(row, index) {
      console.log(row, index);
      if (row.auditRemark) {
        return false;
      }
      return true;
    },
    getLookupTypeCode: function getLookupTypeCode() {
      var _this14 = this;
      var param = {
        configItemCodeList: ['TEAM_TYPE']
      };
      this.$api.common.getConfigItemByCode(param).then(function (res) {
        _this14.lookupList = JSON.parse(JSON.stringify(res.data || {}));
        // 查找值数据转换
        for (var key in _this14.lookupList) {
          _this14.generateMapping(key, _this14.lookupList[key] || []);
        }
        _this14.searchData();
      }).catch(function () {
        console.log('Data Request Fail');
      });
    },
    generateMapping: function generateMapping(title, dataList) {
      var _this15 = this;
      // 将查找值转换成所需数据格式
      this.lookupList["".concat(title, "_MAPPING")] = {};
      dataList.forEach(function (item) {
        var name = item.name,
          code = item.code;
        _this15.lookupList["".concat(title, "_MAPPING")][code] = name;
      });
    }
  }
};